import { render, staticRenderFns } from "./MilestoneList.vue?vue&type=template&id=a44e00c4"
import script from "./MilestoneList.vue?vue&type=script&lang=js"
export * from "./MilestoneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports